import { AxiosResponse } from "axios";
import { axiosInstance } from "./axiosInstance";

const base = (campusId: number) => `/admin/campus/${campusId}/aulasEnVivo`;

/** Aulas En Vivo: lo que hay abierto en el aula virtual, y la entrada a supervisar (enlace WAPP de un solo uso). */
export class AulasEnVivoService {
	list = async (campusId: number): Promise<AxiosResponse<any>> => axiosInstance.get<any>(base(campusId));

	supervise = async (campusId: number, scheduleId: number): Promise<AxiosResponse<any>> =>
		axiosInstance.post<any>(`${base(campusId)}/${scheduleId}/_supervise`);
}
